import { isNil } from 'lodash/fp'
import log from 'loglevel'

import environments from './environments.json'

type Environment = {
  name: string
  release: string
  dist: string
  version: string
  localhost: boolean
  nodeEnv: 'production' | 'development' | 'test'
  publicUrl: string
  logLevel: log.LogLevelDesc
  sentryDsn?: string
}
type Environments = Record<string, Configuration>
type Configuration = {
  sentryDsn?: string
}

const localhost =
  /^(?:localhost|127(?:\.(?:[0-9]|[1-9][0-9]{1,2}|2[0-4][0-9]|25[0-5])){3}|\[::1\])$/.test(
    globalThis.location.hostname
  )
const name = process.env['REACT_APP_ENV'] ?? 'local'
const release = process.env['REACT_APP_RELEASE'] ?? 'none'
const dist = process.env['REACT_APP_DIST'] ?? 'none'
const version = process.env['REACT_APP_VERSION'] ?? 'none'
const nodeEnv = process.env.NODE_ENV
const publicUrl = process.env.PUBLIC_URL
const logLevel =
  (process.env['REACT_APP_LOG_LEVEL'] as log.LogLevelDesc) ??
  (nodeEnv === 'development' ? log.levels.TRACE : log.levels.INFO)

export const environment: Environment = (() => {
  const environment = {
    name,
    release,
    dist,
    version,
    localhost,
    nodeEnv,
    publicUrl,
    logLevel
  }
  const configuration = (environments as Environments)[name]
  if (!isNil(configuration)) {
    for (const property in configuration) {
      // @ts-expect-error: use bracket notation to dynamically access object properties
      environment[property] = configuration[property]
    }
  } else {
    log.warn('[environment] No configuration found for environment', name)
  }
  return environment
})()
